import { U21SideMenu } from 'app/shared/u21-ui/components/dashboard';
import { AIRecommendationSidebarDefinition } from 'app/modules/sidebar/models';
import { useGetAIResults } from 'app/modules/aiAgentResults/queries/useGetAIResults';
import {
  U21LoadError,
  U21NoData,
  U21Spacer,
  U21Subsection,
  U21Typography,
} from 'app/shared/u21-ui/components';
import { useGetAlert } from 'app/modules/alerts/queries/useGetAlert';
import { AILoading } from 'app/modules/ai/components/AILoading';
import { IconFlag } from '@u21/tabler-icons';
import { AIMarkdown } from 'app/modules/ai/components/AIMarkdown';
import { AiAgentRecommendationChip } from 'app/modules/aiAgentResults/components/AiAgentRecommendationChip';

interface Props {
  data: AIRecommendationSidebarDefinition['data'];
}

export const SidebarAIRecommendation = (props: Props) => {
  const {
    data: { id, type },
  } = props;

  const {
    alert,
    query: {
      isError: isAlertError,
      isLoading: isAlertLoading,
      refetch: refetchAlert,
    },
  } = useGetAlert(Number(id));

  const {
    data: aiResult,
    isError: isAIResultsError,
    isLoading: isAIResultsLoading,
    refetch: refetchAIResults,
  } = useGetAIResults({
    relation_id: id,
    relation_type: type,
  });

  return (
    <U21SideMenu
      loading={isAlertLoading || isAIResultsLoading}
      noPadding
      title={
        <U21Spacer horizontal>
          <U21Typography variant="h4">AI Recommendation</U21Typography>
          {(aiResult?.decision_agent_recommendation ||
            aiResult?.decision_agent_recommendation === null) && (
            <AiAgentRecommendationChip
              id={id}
              type={type}
              value={aiResult.decision_agent_recommendation}
            />
          )}
        </U21Spacer>
      }
    >
      {(() => {
        if (isAlertError) {
          return (
            <U21LoadError label="alert" onTryAgain={() => refetchAlert()} />
          );
        }
        if (isAIResultsError) {
          return (
            <U21LoadError
              label="AI agent results"
              onTryAgain={() => refetchAIResults()}
            />
          );
        }

        if (aiResult?.is_reviewing) {
          return <AILoading />;
        }
        if (!aiResult?.decision_agent_recommendation_reasoning) {
          return <U21NoData>No recommendation reasoning found.</U21NoData>;
        }
        if (!alert) {
          return <U21NoData>Alert not found.</U21NoData>;
        }
        return (
          <U21Subsection
            disableTitleCase
            shadedHeader
            title={alert.title}
            titleIcon={<IconFlag />}
          >
            <AIMarkdown>
              {aiResult?.decision_agent_recommendation_reasoning}
            </AIMarkdown>
          </U21Subsection>
        );
      })()}
    </U21SideMenu>
  );
};
